import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'WeeklyPlanSearchPipe', pure: false,
    standalone: false
})
export class WeeklyPlanSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(plan => {
        if (plan.name) {
          return plan.name.search(searchText) !== -1;
        }
      });
    }
  }
}
